import React, { useState } from 'react';
import Step1CompanyInfo from './Step1companyinfo';
import Step2moduleselection from './Step2moduleselection';
import AppTheme from '../../shared-theme/AppTheme';
import SubmitOnboaringScreen from './SubmitOnboardingScreen';

const OnBoardingLayout = (props) => {

    const[step, setStep] = useState(1);

    const initialForm = {};

    const [form, setForm] = useState(initialForm);

    const handleNext  = ()=>{
        setStep(step + 1);
    }

    const handleBack = () => {
        if (step > 1) {
        setStep(step - 1);
        }
    }

    return (
        <AppTheme {...props}>

            {step === 1 && (
            <Step1CompanyInfo form={form} setForm={setForm} onNext={handleNext} ></Step1CompanyInfo>
            )}

            {step === 2 && (
            <Step2moduleselection form={form} setForm={setForm} onBack={handleBack} onNext={handleNext}></Step2moduleselection>
            )}

            {step === 3 && (
            <SubmitOnboaringScreen form={form} setForm={setForm} onBack={handleBack} onNext={handleNext}></SubmitOnboaringScreen>
            )}

        </AppTheme>
    );
};

export default OnBoardingLayout;
